const adUtil = require('../../lib/adUtil');

module.exports = {
    // The properties of each event object is defined in https://dash.permutive.com/events
    createEventObject: (eventName, adInfo) => {
        const baseModel = window.phxPageTarget.config.global.baseModel;
        const adData = adInfo?.ima?.ad?.data;

        if (['VideoAdClicked', 'VideoAdView'].includes(eventName)) {
            const eventObject = {
                local_time: new Date(),
                ad: {
                    line_item_id: adData?.adWrapperIds?.at?.(-1),
                    title: adInfo.adtitle ?? adData?.title,
                    duration: Math.round(adInfo.duration ?? adData?.duration),
                },
                client: {
                    domain: baseModel.hostname,
                    title: document.title,
                    referrer: adUtil.getReferrer(),
                    user_agent: navigator.userAgent,
                },
            };

            if (adData?.clickThroughUrl) {
                try {
                    const clickThroughUrl = new URL(adData.clickThroughUrl);
                    const adurlUrl = new URL(clickThroughUrl.searchParams.get('adurl'));
                    const campaignId = adurlUrl.searchParams.get('utm_campaign');
                    if (campaignId !== null) {
                        eventObject.ad.campaign_id = campaignId;
                    }
                } catch {}
            }

            eventObject.client.url = window.location.protocol + '//' + baseModel.hostname + baseModel.path;
            return eventObject;
        }
    },
};
